export const TOGGLE_ADO = 'TOGGLE_ADO';
export const TOGGLE_JIRA = 'TOGGLE_JIRA';